<template>
	<div class="user-profile-page">
		<h1 class="vl-font--size-30 color-white">{{ $t("profile.greeting") }} {{ user?.name }}</h1>

		<div
			class="profiles"
			v-if="user?.subscriber_profile_profiles && user?.subscriber_profile_profiles.length === 3"
			v-focus-section
		>
			<UserProfile
				v-focus
				v-for="(item, key) in user?.subscriber_profile_profiles"
				:key="key"
				:profileUid="item.id"
			></UserProfile>
		</div>
		<div
			v-else-if="user?.subscriber_profile_profiles && user?.subscriber_profile_profiles.length <= 3"
			class="profiles"
			v-focus-section
		>
			<UserProfile
				v-focus
				v-for="(item, key) in user?.subscriber_profile_profiles"
				:key="key"
				:profileUid="item.id"
			></UserProfile>
			<div class="add-profile" v-focus-section>
				<button class="btn--circle" @click="$router.push('/add-profile')" v-focus>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="default"
						width="8.67mm"
						height="9.37mm"
						viewBox="0 0 24.57 26.56"
					>
						<g id="Layer_2" data-name="Layer 2">
							<g id="Layer_1-2" data-name="Layer 1">
								<line x1="12.28" x2="12.28" y2="26.56" fill="none" stroke="#fff" stroke-width="1.35" />
								<line y1="13.28" x2="24.57" y2="13.28" fill="none" stroke="#fff" stroke-width="1.35" />
							</g>
						</g>
					</svg>
				</button>
				<h2 class="user-profile vl-font-size--18 color-white">{{ $t("profile.add_profile") }}</h2>
			</div>
		</div>
		<div v-else class="profiles" v-focus-section>
			<div class="add-profile" v-focus-section>
				<button class="btn--circle" @click="$router.push('/add-profile')" v-focus>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="default"
						width="8.67mm"
						height="9.37mm"
						viewBox="0 0 24.57 26.56"
					>
						<g id="Layer_2" data-name="Layer 2">
							<g id="Layer_1-2" data-name="Layer 1">
								<line x1="12.28" x2="12.28" y2="26.56" fill="none" stroke="#fff" stroke-width="1.35" />
								<line y1="13.28" x2="24.57" y2="13.28" fill="none" stroke="#fff" stroke-width="1.35" />
							</g>
						</g>
					</svg>
				</button>
				<h2 class="user-profile vl-font-size--18 color-white">{{ $t("profile.add_profile") }}</h2>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, onMounted } from "vue"
	import { useUserStore } from "../stores/user"
	import UserProfile from "../components/UserProfile.vue"
	const userStore = useUserStore()

	const user = computed(() => userStore.state.user)
</script>

<style lang="scss" scoped>
	h1 {
		text-align: center;
		margin: 0 auto 30px;
	}
	.user-profile-page {
		padding-top: 100px;
	}
	.profile-actions {
		display: flex;
		justify-content: center;
		margin-bottom: 40px;
	}
	.btn-devices {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 12px 24px;
		background: rgba(255, 255, 255, 0.1);
		border: 1px solid rgba(255, 255, 255, 0.2);
		border-radius: 8px;
		color: white;
		font-size: 16px;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			background: rgba(255, 255, 255, 0.15);
			border-color: rgba(255, 255, 255, 0.3);
		}

		svg {
			width: 20px;
			height: 20px;
		}
	}
	.profiles {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		gap: 40px;
	}
	.add-profile {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
	}
	button {
		width: 150px;
		height: 150px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		background-color: var(--red);
		border: none;
		cursor: pointer;
		svg {
			width: 50px;
			height: 50px;
			fill: white;
		}
	}
</style>
